import { Button } from "antd";
import { useNavigate } from "react-router-dom";

import styles from "./index.module.scss";

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.notFoundPage}>
      <h1>404</h1>
      <h2 className={styles.subTitle}>Страница не найдена</h2>
      <Button
        type="primary"
        onClick={() => {
          navigate("/");
        }}
      >
        На главную
      </Button>
    </div>
  );
};
